<template>
<div class="border-pic">
  <div class="border-pic__container">
    <product-title class="border-pic__title"
     :descTitleShow="descTitleShow">{{descTitle}}</product-title>
    <div class="border-pic__left-col">
      <component :is="picContent.isLink === true ? 'button' : 'div'"
      @click="$emit('showModal')"
      class="border-pic__picture modal__button">
        <div class="border-pic__image">
          <img class="border-pic__image-pic" alt="border-for-picture" :src="picContent.pic">
          <div v-if="picContent.textShow" class="border-pic__picture_text">
            {{picContent.text}}
          </div>
        </div>

      </component>
    </div>
    <div class="border-pic__right-col">
      <slot name="before-list"></slot>
      <ul class="description__list">
        <check-list v-for="desc in description" :key="desc" :checkListItem="desc" />
      </ul>
      <slot name="after-list"></slot>
    </div>
  </div>
</div>
</template>

<script>
import ProductTitle from '@/components/shared/ProductTitle.vue';
import CheckList from '@/components/shared/listing/CheckList.vue';

export default {
  props: {
    picContent: {
      type: Object,
      default() {
        return {};
      },
    },
    description: {
      type: Array,
      required: true,
    },
    descTitle: {
      type: String,
      default() {
        return '';
      },
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    descTitleShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    };
  },
  components: {
    ProductTitle,
    CheckList,
  },
};
</script>

<style lang="scss" scoped>
$light-gray: #D5D6D7;
$blue: #4DB6BC;
$orange: #F8A81B;
$green: #27AE60;
$coral: #FF7D75;

.border-pic {
  position: relative;
  z-index: 2;

  button.border-pic__picture {
    cursor: pointer;
    background: transparent;
    border: none;
  }

  &.reverse {
    & .border-pic__left-col {
      margin: 0;

      .risc-agro & {
        @media (max-width: 1000px) {
          padding: 40px 0 90px;
        }

        @media (max-width: 910px) {
          padding: 40px 0 55px;
        }

        @media (max-width: 500px) {
          padding: 30px 0 45px;
        }
      }
    }

    .border-pic__container {
      padding: 20px 180px 60px;
      display: grid;
      grid-template-areas:
        "a b"
        "c b";
        max-width: 1600px;
      margin: 0 auto;

      .remote-uav__colums &,
      .technologyai__colums & {
        padding: 30px 0;
        display: grid;
        grid-template-areas:
          "b"
          "c";

        @media (max-width: 480px) {
          padding: 0 0 30px;
        }
      }

      & .border-pic__right-col {
        margin: 0 30px 0 0;
      }

      & .border-pic__picture:after {
        left: 37px;
        width: 100%;

        @media (max-width: 910px) {
          left: 40px;
        }

        @media (max-width: 600px) {
          left: 20px;
        }
      }

      @media (max-width: 1420px) {
        padding: 30px 50px 70px;
      }

      @media (max-width: 1000px) {
        padding: 10px 50px;
        grid-template-areas:
          "a"
          "c"
          "b";
      }

      @media (max-width: 480px) {
        padding: 10px 0px;

        .crop-area &, .plant & {
          padding: 0 25px;
        }

        .risc-agro & {
          padding: 0 25px;
        }
      }
    }

    &.risc-agro__vectors .border-pic__container {
      padding: 55px 180px;

      @media (max-width: 1420px) {
        padding: 70px 50px;
      }

      @media (max-width: 1275px) {
        padding: 70px 50px 40px;
      }

      @media (max-width: 1000px) {
        padding: 50px 50px 0;
        grid-template-areas:
          "a"
          "c"
          "b";
      }

      @media (max-width: 480px) {
          padding: 30px 30px 0;
        }
    }
  }

  &__container {
    padding: 40px 180px 60px;
    color: $light-gray;
    display: grid;
    grid-template-areas:
      "a a"
      "b c";

    .scoring__desc & {
      grid-template-areas:
        "b a"
        "b c";
      max-width: 1600px;
      margin: 0 auto;
      padding: 40px 110px 60px;
      grid-template-columns: 1fr 1fr;

      @media (max-width: 1275px) {
        padding: 40px 110px;
      }

      @media (max-width: 1275px) {
        padding: 0 50px;
        grid-template-columns: initial;
      }

        @media (max-width: 1000px) {
          grid-template-areas:
            "b"
            "a"
            "c";
          margin: 0 0 30px;
        }

        @media (max-width: 560px) {
          padding: 0 30px;
          margin: 0;
        }

        @media (max-width: 480px) {
          padding: 30px;
        }
    }

    .cadastre &, .risc-agro & {
      max-width: 1600px;
      margin: 0 auto;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        "b c";
        padding: 0;

      @media (max-width: 1275px) {
        grid-template-columns: initial;
      }

        @media (max-width: 1000px) {
          grid-template-areas:
            "b"
            "a"
            "c";
        }

        @media (max-width: 560px) {
          margin: 0;
        }
    }

    .risc-agro__list &,
    .agrometrika__desc &,
    .risc-agro__advant &,
    .risc-agro__photos &,
    .agrodeposit__desc & {
      padding: 40px 110px 0;
      grid-template-areas:
        "b a"
        "b c"
        "b c";
        max-width: 1600px;
      margin: 0 auto;

        @media (max-width: 1275px) {
          padding: 0 50px;
        }

        @media (max-width: 1000px) {
          grid-template-areas:
            "b"
            "a"
            "c";
        }

        @media (max-width: 560px) {
          padding: 0 30px;
        }

        @media (max-width: 480px) {
          padding: 30px;
        }
      }

      .risc-agro__photos & {
        @media (max-width: 480px) {
          padding: 0 25px;
        }
      }
      .risc-agro__advant & {
        padding: 0 110px 0;
        @media (max-width: 1420px) {
          padding: 0 75px;
        }
        @media (max-width: 1000px) {
          margin: 60px 0;
          grid-template-areas:
            "a"
            "c"
            "b";
        }
        @media (max-width: 480px) {
          padding: 0;
          margin: 0;
        }
      }

    .class-agro__desc & {
      background: $blue;
    }

    .remote-uav__colums &,
    .technologyai__colums & {
      padding: 30px 0;
      display: grid;
      grid-template-areas:
        "c"
        "b";
        max-width: 1600px;
      margin: 0 auto;

      @media (max-width: 1000px) {
        grid-template-areas:
          "b"
          "c";
      }

      @media (max-width: 480px) {
        padding: 30px 0;
      }
    }

    .grid-left & {
      grid-template-areas:
        "b a"
        "b c";
        max-width: 1600px;
      margin: 0 auto;
        @media (max-width: 720px) {
          grid-template-areas:
            "b"
            "a"
            "c";
        }
    }

    .invasive & {
      padding: 0 180px;
      grid-template-areas:
      ". . a"
      "b b c";
      @media (max-width: 1275px) {
        padding: 0 50px;
      }
      @media (max-width: 970px) {
        grid-template-areas:
          "b"
          "a"
          "c";
      }
      @media (max-width: 560px) {
        padding: 0 30px;
      }

      @media (max-width: 480px) {
        padding: 30px;
      }
    }

    .grid-right & {
      grid-template-areas:
      "a c"
      "b c"
      ". c";
      max-width: 1600px;
      margin: 0 auto;
      @media (max-width: 990px) {
      grid-template-areas:
        "b"
        "a"
        "c";
      &  .border-pic__title {
          margin: 75px 10px 30px 0;
          @media (max-width: 910px) {
            margin: 40px 10px 30px 0;
          }
        }
      }
    }
    .description_white & {
      grid-template-areas:
        "a a ."
        "b b c";

      @media (max-width: 990px) {
      grid-template-areas:
        "a"
        "b"
        "c";
      }
    }

    @media (max-width: 1275px) {
      padding: 40px 50px;
    }

    @media (max-width: 1000px) {
      .risc-agro__photos & {
        grid-template-areas:
            "a"
            "c"
            "b";
      }
    }

    @media (max-width: 910px) {
      grid-template-areas:
        "b"
        "a"
        "c";
    }

    @media (max-width: 480px) {
      padding: 30px;
    }
  }

  &__left-col {
    margin: 0 45px 0 0;
    grid-area: b;

    .remote-uav__colums &,
    .technologyai__colums & {
      margin: 0 0 60px 0;
    }

    @media (max-width: 1000px) {
      .risc-agro__list &,
      .agrometrika__desc & {
          width: 90%;
          margin: 0 0 60px;
      }
      .risc-agro__advant &,
      .risc-agro__vectors &,
      .risc-agro__photos &,
      .risc-agro__index & {
        width: 90%;
        margin: 40px 0 0;
      }

      .scoring__desc & {
        margin: 0 0 60px;
      }
    }

    @media (max-width: 970px) {
      .invasive & {
        margin: 0 0 45px 0;
      }
    }

    @media (max-width: 910px) {
      width: 90%;
      margin: 30px 0 20px;
      .agrometrika__list & {
        width: 100%;
        margin: 0;
      }
    }
  }

  &__right-col {
    grid-area: c;

    .remote-uav__colums &,
    .technologyai__colums & {
      margin: 0 0 20px;
    }

    @media (max-width: 910px) {
      width: 100%;
    }
  }

  &__title {
    grid-area: a;
    margin: 0 20px 30px 0;
  }

  &__text {
    font-size: 16px;
    line-height: 22px;
  }

  &__picture {
    position: relative;

  &_text {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #d5d6d7;
    background-color: #555A60;
    padding: 15px 0 0;
  }

    .description_white & {
      @media (max-width: 990px) {
        margin:  0 0 60px;
      }
    }

    @media (max-width: 910px) {
      margin:  0 0 30px;
    }

    &:after {
      content: "";
      position: absolute;
      border: 1px solid $blue;
      border-radius: 20px;
      top: 35px;
      left: -50px;
      width: 85%;
      height: 100%;

      .invasive & {
       content: none;
      }

      .check-list_orange & {
        border: 1px solid $orange;
      }

      .description_white & {
        border: 1px solid #fff;
      }

      .check-list_green & {
        border: 1px solid $green;
        @media (max-width: 910px) {
          left: 40px;
          width: 100%;
        }
      }

      .check-list_violet & {
        border: 1px solid #8293E8;
        @media (max-width: 910px) {
          left: 40px;
          width: 100%;
        }
      }

      .check-list_coral & {
        border: 1px solid $coral;
        @media (max-width: 910px) {
          left: 40px;
          width: 100%;
        }
      }

      @media (max-width: 1275px) {
        left: -23px;
        width: 73%;
      }

      @media (max-width: 600px) {
        width: 100%;
      }
    }
  }

  &__image {
    border-radius: 32px;
    overflow: hidden;
    z-index: 20;
    position: relative;

    .risc-agro__list &,
    .agrometrika__desc & {
      max-height: 350px;

      @media (max-width: 830px) {
        max-height: 300px;
      }
    }

    .plant & {
      max-width: 700px;
    }
    .forestly & {
      max-width: 70%;
    margin: 0 auto;
    }

    .risc-agro__container & {
      max-width: 595px;
      @media (max-width: 1500px) {
        max-width: 550px;
      }
    }

    .description_white & {
      border-radius: 10px;
      max-width: 700px;
    }

    .border-pic_gray & {
      border: 31px #555A60 solid;
      border-radius: 12px;

        @media (max-width: 500px) {
          border: 16px #555A60 solid;
        }
    }

    .scoring__desc & {
      @media (max-width: 1000px) {
        max-width: 360px;
      }
    }

    @media (max-width: 480px) {
      width: 100%;
    }

    &-pic {
      width: 100%;
      object-fit: cover;
      height: 100%;
      display: block;

      .risc-agro__list & {
        transform: scale(-1, 1);
      }

      @media (max-width: 910px) {
        max-height: 370px;
      }

    }
  }

  &__item {
    display: flex;
    align-items: center;
    margin: 30px 0 0;
    font-family: 'montserratbold', sans-serif;
    font-size: 16px;
    line-height: 22px;

    @media (max-width: 550px) {
      margin: 20px 0 0;
    }
  }

  &__icon {
    margin: 0 10px 0 0;
  }
}
.description {
  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
